import es from "./es.json";
import zh from "./zh.json";
import fr from "./fr.json";

export const SUPPORTED = ["en", "es", "zh", "fr"];
const DICTS: Record<string, Record<string, string>> = { es, zh, fr };
const LOCALES: Record<string, string> = { en: "en-US", es: "es", zh: "zh-CN", fr: "fr" };

const detect = () => {
  const saved = localStorage.getItem("smboi_lang");
  if (saved && SUPPORTED.includes(saved)) return saved;
  const nav = (navigator.language || "en").slice(0, 2);
  return SUPPORTED.includes(nav) ? nav : "en";
};

let current = detect();
document.documentElement.lang = current;

export const getLang = () => current;
export const locale = () => LOCALES[current];

export function setLang(lang: string) {
  current = SUPPORTED.includes(lang) ? lang : "en";
  localStorage.setItem("smboi_lang", current);
  document.documentElement.lang = current;
}

export function t(s: string, vars?: Record<string, string | number>) {
  const out = DICTS[current]?.[s] || s;
  return vars ? out.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? "")) : out;
}
